module.exports = __webpack_public_path__ + "img/yxxx.2b17dabb.png";